import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import * as Layout from 'components/Layout';
import useSearchQuery from 'hooks/useSearchQuery';
import axiosInstance from 'utils/axios';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Loader, PageHeader } from '../components/Global';
import TribeInfo from './sections/TribeInfo/index';
import TribeMember from './sections/TribeMember/index';

const TribeDetail = () => {
  const isMobile = useMediaQuery(({ breakpoints }) => breakpoints.down('md'));
  const { user } = useSelector((state) => state.auth);
  const { tribeId } = useSearchQuery();
  const theme = useTheme();
  const navigate = useNavigate();

  const [tribe, setTribe] = useState('');
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('member');

  const breadcrumbs = useMemo(() => {
    return [
      {
        header: 'Dashboard',
      },
      {
        url: '/tribe',
        header: 'Tribe',
      },
      {
        header: `${tribe.tribeName || ''}`,
        isSelected: true,
      },
    ];
  }, [tribe.tribeName]);

  const fetchTribe = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axiosInstance.get(`/v2/tribe/${tribeId}`, {
        params: {
          disableApprovalFilter: 'true',
        },
      });
      setTribe(data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [tribeId]);

  useEffect(() => {
    fetchTribe();
  }, [fetchTribe]);

  if (tribe) {
    if (Number(user.id) !== tribe.leaderUserId) {
      return navigate('/');
    }
  }

  return (
    <Layout.Responsive>
      <PageHeader
        title={tribe.tribeName}
        breadcrumbs={breadcrumbs}
        badge={
          user.id === tribe.leaderUserId && (
            <Stack
              direction="row"
              height="fit-content"
              borderRadius="40px"
              spacing="2px"
              padding={{ md: '4px 8px 4px 4px', xs: '0px 4px 0px 0px' }}
              backgroundColor="warning500.main"
              alignItems="center"
              border={`1px solid ${theme.palette.warning400.main}`}
            >
              <img
                src="/dashboard/static/icons/crown.svg"
                alt="crown-img"
                width={isMobile ? '18px' : '20px'}
                height={isMobile ? '18px' : '20px'}
              />
              <Typography
                typography={{ md: 'subheading4', xs: 'caption1' }}
                color="warning100.main"
              >
                Leader
              </Typography>
            </Stack>
          )
        }
      />

      {!loading ? (
        <Grid container columnSpacing={3} rowSpacing={3}>
          <Grid item md={7} xs={12}>
            <TribeInfo tribe={tribe} />
          </Grid>
          <Grid item md={5} xs={12}>
            <TribeMember
              tribeMembers={tribe.tribeMembers}
              refetch={fetchTribe}
              activeTab={activeTab}
              setActiveTab={setActiveTab}
            />
          </Grid>
        </Grid>
      ) : (
        <Loader />
      )}
    </Layout.Responsive>
  );
};

export default TribeDetail;
